import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupadminRoutingModule } from './groupadmin-routing.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GroupProfileComponent } from './group-profile/group-profile.component';
import { AdminModule } from '../admin/admin.module';
import { GroupBranchComponent } from './group-branch/group-branch.component';

import { GroupCreateBranchComponent } from './group-create-branch/group-create-branch.component';

import { GroupCreateTicketComponent } from './group-create-ticket/group-create-ticket.component';
import { GroupMyTicketComponent } from './group-my-ticket/group-my-ticket.component';
import { GroupTicketDetailsComponent } from './group-ticket-details/group-ticket-details.component';



@NgModule({
  declarations: [GroupProfileComponent,GroupBranchComponent, GroupCreateTicketComponent, GroupMyTicketComponent, GroupTicketDetailsComponent,GroupCreateBranchComponent],

  imports: [
    CommonModule,
    FormsModule ,
    AdminModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TypeaheadModule.forRoot(),
    GroupadminRoutingModule
  ]
})
export class GroupadminModule { }
